require('./dist/angular-validation-match');
module.exports = 'validation.match';
